require('./command.js');

(function(){
  var timeout;

  PegasusTemplate.AddRowCommand = PegasusTemplate.Command.extend({
    klass: null,
    sourceElement: null,
    callback: null,
    parent: null,
    desiredPosition: null,
    descriptionClass: 'added',
    needsScroll: true,
    description: function(){
      return Em.I18n.t('command_descriptions.added_row');
    }.property(),
    timestamp: null,
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        element,
        callback = this.get('callback'),
        needsScroll = this.get('needsScroll'),
        _super = this._super.bind(this);

      element = this.get('klass').create({
        container: parent.container,
        sourceElement: this.get('sourceElement'),
        dataRowColor: PegasusTemplate.lookupController('toolbar').get('selectedRowColor')
      });

      parent.insertAt( this.get('desiredPosition'), element );

      Em.run.scheduleOnce( 'afterRender', element, function(){
        Em.run.cancel(timeout);
        if( needsScroll ) {
          timeout = Em.run.later(function(){
            try {
              $('body').scrollTo( $('.vr-row').last() );
            } catch(e) {
            }

          }, 150);
        }

        Em.run.scheduleOnce('afterRender', this, function(){
          this.set('sourceElement', this.mutateForOut(null, true).editor_cookie);
          this.$().addClass('bounce-in-left').addClass('animated').addClass('make_transit');
          _super();
        });
      });

      //Em.run.scheduleOnce('afterRender', this, function(){
        //var position = this.get('desiredPosition'),
          //scrollToElementIndex = position - 1;

        //if ( scrollToElementIndex < 0 ) {
          //scrollToElementIndex = 0;
        //}

        //$('.center-panel').scrollTo( PegasusTemplate.blockRegionInstance.objectAt(scrollToElementIndex) );
      //});

      if ( callback ) {
        callback();
      }
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        child = parent.objectAt( this.get('desiredPosition') );

      parent.removeObject(child);
      this._super();
    }
  });
})();
